import React from 'react';
import { genderTypes } from '../../../enums/genderTypes';
import { useSelector } from 'react-redux';

const Text = ({ children, className, elementType = 'p', dangerouslySetInnerHTML = false }) => {
    
    const lang = useSelector(state => state.translate.lang)
    const genderId = useSelector(state => state.auth.userDetails?.genderId);

    const genretedTextByLang = (children) => {

        if (typeof children === 'string') {
            return children
        }

        if (children && typeof children === 'object') {
            if (Object.keys(children).some(key => Object.values(genderTypes).includes(key))) { // support jsones without genders
                return children[genderTypes[genderId]] ? children[genderTypes[genderId]][lang] : children[genderTypes[9]][lang]
            }
            else {
                return children[lang]
            }
        }

        return null
    }

    const Element = elementType;

    return (
        <Element className={className}>
            {dangerouslySetInnerHTML ? <span dangerouslySetInnerHTML={{ __html: genretedTextByLang(children) }} /> : genretedTextByLang(children)}
        </Element>
    );
};

export default Text;
